/**
 *Created by jmmartinez on 13/8/18
 *
 * v.1.1  05/03/2019 Añadido tablaClassName, filaClassName, columnaClassName
 * v.1.2  18/03/2019 Corregido tablaClassName
 * v.1.3  01/05/2020 Pasado a Flex
 * v.2.0  05/11/2020 Pasado a Framework 2.0
 * v.2.1  20/11/2020 Añadida propiedad onCeldaClick
 *                   Añadida propiedad elementoSeleccionado
 * v.2.2  12/12/2020 Añadida propiedad onCeldaDobleClick
 * */

import React from 'react'
import PropTypes from 'prop-types';
import '../../resources/css/tablaflex.css'


class TablaFlex extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datos: props.datos,
            elementoSeleccionado: props.elementoSeleccionado,
        }
    }


    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if(nextProps.datos !== prevState.datos){
            newState.datos= nextProps.datos;
        }

        if(nextProps.elementoSeleccionado !== prevState.elementoSeleccionado){
            newState.elementoSeleccionado= nextProps.elementoSeleccionado;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onCeldaClick= (dato) => {
        const {onCeldaClick} = this.props;
        onCeldaClick && onCeldaClick(dato);
    }

    onCeldaDobleClick= (dato) => {
        const {onCeldaDobleClick} = this.props;
        onCeldaDobleClick && onCeldaDobleClick(dato);
    }

    render() {
        const {datos, elementoSeleccionado} =  this.state;
        //console.log("TablaFelx - Render");
        //console.log("ElementoSeleccionado:");
        //console.log(elementoSeleccionado);
        //console.log(datos);

        return (
            <div className="tabla">
            {
                datos.map ( (dato, index) => {
                    const { children } = this.props;
                    const childrenWithProps = React.Children.map(children, child =>
                        React.cloneElement(child, { dato: dato})
                    );

                    let esElementoActual= elementoSeleccionado && elementoSeleccionado.codigo && dato.codigo == elementoSeleccionado.codigo;

                    return <div key={index} style={ { backgroundColor: esElementoActual ? 'yellow' : 'white'} }
                                onClick={() => this.onCeldaClick(dato)}
                                onDoubleClick={ () => this.onCeldaDobleClick(dato)} >
                                    {childrenWithProps}
                            </div>
                })
            }
            </div>
        );
    }
}



TablaFlex.propTypes = {
    datos: PropTypes.array.isRequired,
    onCeldaClick: PropTypes.func,
    onCeldaDobleClick: PropTypes.func,
    elementoSeleccionado: PropTypes.object,
}

export default TablaFlex
